import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { reports } from '@/mocks/reports';

export default function CategoriesSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20 border-t border-background-200" aria-labelledby="cat-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 id="cat-heading" className="headline-divider font-heading text-xl md:text-2xl font-bold text-foreground-950">
            报道栏目
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {categories.map((cat) => {
            const count = reports.filter((r) => r.category === cat.id).length;
            return (
              <Link
                key={cat.id}
                to={`/reports?cat=${cat.id}`}
                className="group flex flex-col items-center justify-center gap-2 py-6 px-4 bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 rounded-lg transition-all"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 group-hover:bg-primary-100 transition-colors border border-background-200">
                  <i className={`${cat.icon} text-lg text-foreground-700 group-hover:text-primary-600 transition-colors`} />
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{cat.label}</span>
                {count > 0 && (
                  <span className="text-xs text-foreground-400">{count} 篇报道</span>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}